import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import intersectionBy from 'lodash/intersectionBy';
import Button from '../../../components/Button/Button';
import Icon from '../../../../../components/Icon';
import './index.css';

export default function ModalNoBenefit(props) {
  const { isOpen, onClose } = props;
  const sectionList = [
    {
      display: 'Section 4 - Cancelled and Additional Expenses',
      title: 'Cancelled and Additional Expenses',
    },
    {
      display: 'Section 5 - Luggage and Personal Effects',
      title: 'Personal Items',
    },
    {
      display: 'Section 6 - Overseas Medical Expenses',
      title: 'Overseas Medical',
    },
    {
      display: 'Section 7 - Rental Vehicle Expenses',
      title: 'Rental Vehicle',
    },
    {
      display: 'Section 8 - Snow Sports Optional Cover',
      title: 'Snow Sports',
    },
    {
      display: 'Section 9 - Other Claims',
      title: 'Other',
    },
  ];
  const list = intersectionBy(sectionList, props.activeSections, 'title');
  return (
    <Modal style={customStyles} ariaHideApp={false} isOpen={isOpen}>
      <div className={'no-benefit-modal'} />
      <div id="full_description">
        <div
          className="justify-content-between"
          style={{
            textAlign: 'left',
            fontSize: 18,
          }}
        >
          <p>
            No Sections have been completed for your claim. We need to know the
            dates, amounts and details for each item or event you are claiming
            for. Below are the Sections that you can claim under:
          </p>
          <ul className={'list-section-warning'}>
            {list.map((item) => (
              <li key={item.title}>
                <Icon name="fa-exclamation-circle" /> {item.display}
              </li>
            ))}
          </ul>
          <p>
            Please use the Back button and complete at least one Section and
            lodge your claim.
          </p>
        </div>
      </div>
      <div className="row justify-content-center mt-10">
        <div className="col-auto">
          <Button
            backgroundColor="#44b4a6"
            hoverBackgroundColor="#3e9e92"
            padding="13px 25px"
            borderRadius="8px"
            borderColor="transparent"
            fontSize="1em"
            onClick={onClose}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
}

ModalNoBenefit.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  activeSections: PropTypes.array,
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#ffedee',
    color: '#ff0000',
    width: '80%,',
    textAlign: 'left',
    borderRadius: 5,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#b4b4b4',
    minWidth: 400,
    overflow: 'visible',
    maxWidth: 800,
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,.75)',
  },
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/ModalNoBenefit/index.js